import $ from 'jquery';

export default function() {
  // nav tab control

  const $tabControls = $('[data-tab-control] [data-tab-link]');
  const $tabTriggers = $tabControls.find('a');
  const $tabs = $('[data-tab] [data-tab-content]');
  const activeClass = 'State--active';

  $('[data-tab-control] [data-tab-link]:first, [data-tab] [data-tab-content]:first').addClass(activeClass);

  $tabs.each((e) => {
    const $button = $(e.currentTarget);
    if (!$($button).hasClass(activeClass)) {
      $button.hide();
    }
  });

  $tabTriggers.each(function() {
    const $tab = $($(this).attr('href'));
    const $parent = $(this).parent();
    $(this).click((e) => {
      e.preventDefault();
      if (!$parent.hasClass(activeClass)) {
        $tabControls.removeClass(activeClass);
        $tabs.hide();
        $parent.addClass(activeClass);
        $tab.show().css('opacity', 0).animate({
          opacity: 1,
        }, 1000);
      }
    });
  });
  $('[data-tab-title]').on('click', (e) => {
    $(e.currentTarget).toggleClass('State--active');
    $('[data-tab-control]').toggleClass('State--active');
  });

  $('[data-tab-link]').on('click', () => {
    $('[data-tab-control]').removeClass('State--active');
    $('[data-tab-title]').removeClass('State--active');
  });

}
